import React from "react";
import { CheckBoxInput, RadioInput } from "../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { facilityAction } from "../../_store";
import ToggleSwitch from "../../components/common/ui/Inputs/ToggleSwitch";

function AccessiblePermission({ errorMessage, setErrorMessage }) {
  const dispatch = useDispatch();
  const facilityInformationData = useSelector((x) => x?.facility?.facilityData);
  const { FacilityInformationmportTypeOption } = useSelector(
    (state) => state.dropdownOptions
  );

  const handleChange = (e) => {
    let facilityData = { ...facilityInformationData };
    const { name, checked, value, type } = e?.target;

    if (name === "IsMessageAcess" && !checked) {
      facilityData["IsReview"] = 0;
      setErrorMessage((prev) => ({
        ...prev,
        FacilityMessageCost: "",
      }));
    }
    if (
      (name === "IsPhotoAccess" &&
        !checked &&
        facilityData?.IsMessageAcess !== 1) ||
      (name === "IsMessageAcess" &&
        !checked &&
        facilityData?.IsPhotoAccess !== 1)
    ) {
      setErrorMessage((prev) => ({
        ...prev,
        FacilityEmojiCost: "",
        FacilityMessageCost: "",
        FacilityPhotoCost: "",
      }));
    }
    if (name === "IsPhotoAccess" && !checked) {
      setErrorMessage((prev) => ({
        ...prev,
        FacilityPhotoCost: "",
      }));
    }
    if (name === "IsEcardAccess" && !checked) {
      setErrorMessage((prev) => ({
        ...prev,
        FacilityEcardCost: "",
      }));
    }
    if (name === "IsEmojiEnabled" && !checked) {
      setErrorMessage((prev) => ({
        ...prev,
        FacilityEmojiCost: "",
      }));
    }

    if (name === "InmateUploadType") {
      setErrorMessage((prev) => ({
        ...prev,
        FTPServerURL: "",
        FTPUserName: "",
        FTPPassword: "",
        FTPFilePath: "",
        CactasURL:
          facilityData?.IsInmateCactasCredit !== 1
            ? ""
            : prev?.CactasURL
              ? prev?.CactasURL
              : "",
        CactasAccessKey:
          facilityData?.IsInmateCactasCredit !== 1
            ? ""
            : prev?.CactasAccessKey
              ? prev?.CactasAccessKey
              : "",
      }));
    }

    if (name === "IsInmateInvitePublic" && !checked) {
      facilityData.InmateInvitePublicActiveStatus = 1;
      setErrorMessage((prev) => ({
        ...prev,
        InmateInvitePublicFrequencyType: "",
        InmateInvitePublicCount: "",
        InmateInvitePublicRepeatLimit: "",
      }));
    }

    if (name === "IsLawLibraryAccess" && !checked) {
      setErrorMessage((prev) => ({
        ...prev,
        LawLibraryLink: "",
      }));
    }

    if (name === "IsCommissaryAccess" && !checked) {
      setErrorMessage((prev) => {
        const updatedErrorMessage = { ...prev, CommissaryAccessLink: "" };
        for (let i = 1; i <= 7; i++) {
          updatedErrorMessage[
            `Type_CommissaryAccessInterval.${i}.AccessFromTime`
          ] = "";
          updatedErrorMessage[
            `Type_CommissaryAccessInterval.${i}.AccessToTime`
          ] = "";
        }
        return updatedErrorMessage;
      });
    }

    if (name === "IsInmateFreeCredit" && !checked) {
      facilityData.FreeCreditActiveStatus = 1;
      setErrorMessage((prev) => ({
        ...prev,
        InmateFreeCreditFrequencyType: "",
        InmateFreeCreditAmount: "",
      }));
    }

    if (
      name === "IsInmateCactasCredit" &&
      !checked &&
      facilityData?.InmateUploadType !== 2
    ) {
      setErrorMessage((prev) => ({
        ...prev,
        CactasURL: "",
        CactasAccessKey: "",
      }));
    }

    if (
      facilityData?.IsEmojiEnabled === 1 &&
      (facilityData?.IsMessageAcess === 1 ||
        facilityData?.IsPhotoAccess === 1 ||
        facilityData?.IsEcardAccess === 1)
    ) {
      facilityData["IsEmojiEnabled"] = 1;
    } else {
      facilityData["IsEmojiEnabled"] = 0;
    }
    facilityData[name] =
      type === "checkbox"
        ? checked
          ? 1
          : 0
        : type === "radio"
          ? parseInt(value)
          : value;
    dispatch(facilityAction?.setFacilityData(facilityData));
  };
  return (
    <div className="mt-3 mb-3">
      <h4
        className="inner-header-bg text-color"
        style={{ cursor: "pointer" }}
        title="To set the menu permissions for the inmate and the public user"
      >
        <i className="fas fa-shield-alt me-2"></i>Accessible Permissions{" "}
      </h4>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <CheckBoxInput
              label={"Messages"}
              name="IsMessageAcess"
              id="IsMessageAcess"
              handleClick={handleChange}
              errorMessage={errorMessage}
              checked={facilityInformationData?.IsMessageAcess === 1}
            />
          </div>
        </div>

        {facilityInformationData?.IsMessageAcess === 1 && (
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <CheckBoxInput
                label={"Message Reviews"}
                name="IsReview"
                id="IsReview"
                handleClick={handleChange}
                errorMessage={errorMessage}
                checked={facilityInformationData?.IsReview}
              />
            </div>
          </div>
        )}

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <CheckBoxInput
              label={"Postal Mails"}
              name="IsMailScanningAccess"
              id="IsMailScanningAccess"
              handleClick={handleChange}
              checked={facilityInformationData?.IsMailScanningAccess === 1}
              errorMessage={errorMessage}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <CheckBoxInput
              label="Documents"
              name="IsDocumentsAccess"
              id="IsDocumentsAccess"
              handleClick={handleChange}
              checked={facilityInformationData?.IsDocumentsAccess === 1}
              errorMessage={errorMessage}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <CheckBoxInput
              label="Photos"
              name="IsPhotoAccess"
              id="IsPhotoAccess"
              handleClick={handleChange}
              checked={facilityInformationData?.IsPhotoAccess === 1}
              errorMessage={errorMessage}
            />
          </div>
        </div>

        {(facilityInformationData?.IsMessageAcess === 1 ||
          facilityInformationData?.IsPhotoAccess === 1 ||
          facilityInformationData?.IsEcardAccess === 1) && (
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="form-floating mb-3">
                <CheckBoxInput
                  label="Emojis"
                  name="IsEmojiEnabled"
                  id="IsEmojiEnabled"
                  handleClick={handleChange}
                  checked={facilityInformationData?.IsEmojiEnabled}
                  errorMessage={errorMessage}
                />
              </div>
            </div>
          )}

        <div className="col-sm-6 col-md-6 col-lg-3 d-flex flex wrap">
          <div className="form-floating">
            <CheckBoxInput
              label="E-Cards"
              name="IsEcardAccess"
              id="IsEcardAccess"
              handleClick={handleChange}
              errorMessage={errorMessage}
              value={facilityInformationData?.IsEcardAccess}
              checked={facilityInformationData?.IsEcardAccess === 1}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3 d-flex flex wrap">
          <div className="form-floating">
            <CheckBoxInput
              label={"Grievances/Requests"}
              name="IsFormReqAccess"
              id="IsFormReqAccess"
              handleClick={handleChange}
              errorMessage={errorMessage}
              value={facilityInformationData?.IsFormReqAccess}
              checked={facilityInformationData?.IsFormReqAccess === 1}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <CheckBoxInput
              label={"Law Library"}
              name="IsLawLibraryAccess"
              id="IsLawLibraryAccess"
              handleClick={handleChange}
              checked={facilityInformationData?.IsLawLibraryAccess === 1}
              errorMessage={errorMessage}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <CheckBoxInput
              label={"Commissary"}
              name="IsCommissaryAccess"
              id="IsCommissaryAccess"
              handleClick={handleChange}
              checked={facilityInformationData?.IsCommissaryAccess === 1}
              errorMessage={errorMessage}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <CheckBoxInput
              label={"Invite Public Users"}
              name="IsInmateInvitePublic"
              id="IsInmateInvitePublic"
              handleClick={handleChange}
              checked={facilityInformationData?.IsInmateInvitePublic}
              errorMessage={errorMessage}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <CheckBoxInput
              label={"Free Credits"}
              name="IsInmateFreeCredit"
              id="IsInmateFreeCredit"
              handleClick={handleChange}
              checked={facilityInformationData?.IsInmateFreeCredit}
              errorMessage={errorMessage}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <CheckBoxInput
              label={"Display Current Date"}
              name="DisplayCurrentDate"
              id="DisplayCurrentDate"
              handleClick={handleChange}
              checked={facilityInformationData?.DisplayCurrentDate}
              errorMessage={errorMessage}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <CheckBoxInput
              label={"CACTAS Credits"}
              name="IsInmateCactasCredit"
              id="IsInmateCactasCredit"
              handleClick={handleChange}
              checked={facilityInformationData?.IsInmateCactasCredit}
              errorMessage={errorMessage}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <CheckBoxInput
              label={"Connection Request Approvals"}
              name="IsApprovalRequiredForConnectionRequest"
              id="IsApprovalRequiredForConnectionRequest"
              handleClick={handleChange}
              checked={
                facilityInformationData?.IsApprovalRequiredForConnectionRequest
              }
              errorMessage={errorMessage}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <CheckBoxInput
              label={"Disable Purchase"}
              name="IsPurchaseDisabled"
              id="IsPurchaseDisabled"
              handleClick={handleChange}
              checked={facilityInformationData?.IsPurchaseDisabled}
              errorMessage={errorMessage}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <RadioInput
              label="Inmate Import Type"
              name="InmateUploadType"
              id="InmateUploadType"
              options={FacilityInformationmportTypeOption}
              handleChange={(e) => handleChange(e)}
              errorMessage={errorMessage}
              selectedValue={facilityInformationData?.InmateUploadType}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(AccessiblePermission);
